import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./Badge.vue.script.js";
/* empty css                    */
//#region src/shared/Badge.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-2a7101e8"]]);
//#endregion
export { n as default };

//# sourceMappingURL=Badge.vue.js.map